module.exports = __webpack_public_path__ + "static/chickhamper-4cb3f261cc146c86689b57b7c0606b91.jpeg";